import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../../providers/auth/auth';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';

import {RegistrationParent} from '../../models/registrationparent';

/**
 * Generated class for the UpdateRegistrationParentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-parent',
  templateUrl: 'update-registration-parent.html',
})
export class UpdateRegistrationParentPage {

  private user: any;
  public registrationParent: RegistrationParent;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider
  ) {
    this.registrationParent = new RegistrationParent();

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationParent.motherName = this.user.motherName;
      this.registrationParent.fatherName = this.user.fatherName;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationParentPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doSave() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar os dados pessoais.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationParent.motherName)) {
      this.alertProvider.doAlert('Forneça o nome de sua mãe.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar os dados dos seus pais ou responsáveis?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updateParent(that.registrationParent).subscribe((response: any) => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Seus pais ou responsáveis foram salvos com sucesso.', 'Informação');
            loader.dismiss();

            // Update local user data
            that.user.motherName = that.registrationParent.motherName;
            that.user.fatherName = that.registrationParent.fatherName;

            that.authProvider.setUser(that.user);
            that.eventEmitterProvider.get('registration_updated').emit(that.user);

            that.onBack();
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao tentar salvar seus pais ou responsáveis. Tente novamente mais tarde.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Houve problemas ao tentar salvar seus pais ou responsáveis. Tente novamente mais tarde.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-parent/update-registration-parent.ts